import { LocaleEnum } from '@systemeio/ui'
import Script from 'next/script'
import { useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { HelpScoutArrowIcon } from './help-scout-arrow-icon'
import { HelpScoutQuestionMarkIcon } from './help-scout-question-mark-icon'

const beaconConfig = {
  display: {
    style: 'manual',
  },
}

interface HelpScoutProps {
  shouldRender: boolean
  locale: LocaleEnum
}

export function HelpScout({ shouldRender, locale }: HelpScoutProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = () => {
    window.Beacon?.('toggle')
  }

  useEffect(() => {
    if (!window.Beacon) return

    if (window.Beacon('info')) {
      window.Beacon('destroy')
    }

    if (!shouldRender) {
      if (window.Beacon('info')) {
        window.Beacon('destroy')
      }
      return
    }

    const beaconId =
      locale === LocaleEnum.FRENCH
        ? 'aaa8207b-5330-444e-874f-2932dbd59c04'
        : '616a9e89-fc77-408c-995e-d7f589d575d7'

    window.Beacon('init', beaconId)
    window.Beacon('config', beaconConfig)

    window.Beacon('on', 'open', () => setIsOpen(true))
    window.Beacon('on', 'close', () => setIsOpen(false))

    return () => {
      window.Beacon('off', 'open')
      window.Beacon('off', 'close')
      setIsOpen(false)
    }
  }, [shouldRender, locale])

  return (
    <>
      <Script
        id={'help-scout'}
        dangerouslySetInnerHTML={{
          __html: `!function (e, t, n) {
          function a() {
              var e = t.getElementsByTagName("script")[0], n = t.createElement("script");
              n.type = "text/javascript", n.async = !0, n.src = "https://beacon-v2.helpscout.net", e.parentNode.insertBefore(n, e)
              }
              if (e.Beacon = n = function (t, n, a) {
                e.Beacon.readyQueue.push({method: t, options: n, data: a})
                }, n.readyQueue = [], "complete" === t.readyState) return a();
                e.attachEvent ? e.attachEvent("onload", a) : e.addEventListener("load", a, !1)
                }(window, document, window.Beacon || function () {
                  });`,
        }}
      />

      {shouldRender && (
        <button
          onClick={handleToggle}
          className={twMerge(
            'bg-text-primary fixed -right-2 bottom-16 z-50 flex h-12 w-8 items-center justify-center rounded-l-md pr-2 shadow-lg md:w-14',
            'transition-transform duration-300 ease-in-out hover:scale-110 hover:shadow-xl',
            'active:scale-90 md:active:scale-100',
          )}
        >
          <span className="relative h-full w-full">
            <span
              className={twMerge(
                'absolute inset-0 flex transform items-center justify-center transition-all duration-300 ease-in-out',
                isOpen ? 'scale-0 opacity-0' : 'scale-100 opacity-100',
              )}
            >
              <HelpScoutQuestionMarkIcon />
            </span>
            <span
              className={twMerge(
                'absolute inset-0 flex transform items-center justify-center transition-all duration-300 ease-in-out',
                isOpen ? 'scale-100 opacity-100' : 'scale-0 opacity-0',
              )}
            >
              <HelpScoutArrowIcon />
            </span>
          </span>
        </button>
      )}
    </>
  )
}
